<template>
  <a-layout>
    <a-spin :spinning="loading">
      <a-form-model :colon="false" :form="form" :label-col="labelCol" :model="menu" :rules="rules" :wrapper-col="wrapperCol" style="margin-left: -2%;margin-right: 2%">
        <a-row>
          <a-col span="12">
            <a-form-model-item :label="$t('business.label.menuId')">
              <vxe-input v-model="menu.id" disabled style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col span="12">
            <a-form-model-item :label="$t('business.label.parentMenu')">
              <vxe-input v-model="menu.parent.name" disabled style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col span="12">
            <a-form-model-item :label="$t('business.label.menuNo')">
              <vxe-input v-model="menu.no" style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col span="12">
            <a-form-model-item :label="$t('business.label.menuName')">
              <vxe-input v-model="menu.name" style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col span="12">
            <a-form-model-item :label="$t('business.label.url')">
              <vxe-input v-model="menu.url" style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col span="12">
            <a-form-model-item :label="$t('business.label.icon')">
              <vxe-input v-model="menu.icon" style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col span="12">
            <a-form-model-item :label="$t('business.label.application')">
              <a-select v-model="menu.application">
                <a-select-option v-for="d in applications" :key="d.ordinal">{{ d.name }}</a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col span="12">
            <a-form-model-item label="组件名">
              <vxe-input v-model="menu.parameter.component" style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col span="12">
            <a-form-model-item label="组件描述">
              <vxe-input v-model="menu.parameter.meta.title" style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col span="12">
            <a-form-model-item label="组件图标">
              <vxe-input v-model="menu.parameter.meta.icon" style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col span="12">
            <a-form-model-item :label="$t('business.label.menuOrdinal')">
              <vxe-number-input v-model="menu.ordinal" style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col span="12">
            <a-form-model-item :label="$t('business.label.reportNo')">
              <vxe-input v-model="menu.query.name" style="width: 100%"/>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col span="24">
            <a-form-model-item :label="$t('business.label.available')" :label-col="{span:4}" :wrapper-col="labelCol">
              <vxe-switch v-model="menu.available" size="mini"/>
            </a-form-model-item>
          </a-col>
          <a-col span="24">
            <a-form-model-item :label="$t('business.label.functional')" :label-col="{span:4}" :wrapper-col="labelCol">
              <vxe-switch v-model="menu.functional" size="mini"/>
            </a-form-model-item>
          </a-col>
          <a-col span="24">
            <a-form-model-item :label="$t('business.label.leaf')" :label-col="{span:4}" :wrapper-col="labelCol">
              <vxe-switch v-model="menu.leaf" size="mini"/>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </a-spin>
  </a-layout>
</template>

<script>
import { findEnum, findOne, save } from '@/api/Api'
import { Menu } from '@/api/dto/menu/Menu'

export default {
    name: 'MenuDetail',
    data() {
      return {
        form: this.$form.createForm(this),
        menu: new Menu(),
        applications: [],
        loading: false,
        labelCol: {span: 8},
        wrapperCol: {span: 16},
        rules: {
          no: [
            {required: true, message: '菜单编号不能为空'}
          ],
          name: [
            {required: true, message: '菜单名称不能为空'}
          ],
          application: [
            {required: true, message: '应用类型不能为空'}
          ]
        }
      }
    },
    mounted() {
      findEnum('Application').then(res => {
        this.applications = res.result
      })
    },
    methods: {
      getData(id) {
        this.loading = true
        findOne('menuFactory', {id: id}).then(res => {
          if (res.success) {
            this.menu = new Menu(res.result)
          }
        }).finally(() => this.loading = false)
      },
      save() {
        this.loading = true
        const menu = this.menu.toJSONObject()
        save('menuPersister', menu).then(res => {
          if (res.success) {
            this.menu = new Menu(res.result)
            this.$message.success(this.$t('message.saveSuccess'))
          }
        }).finally(() => this.loading = false)
      },
      delete() {
        if (this.menu.isNew()) {
          return this.$warning({
            title: '请先选择左侧需要删除的菜单',
            centered: true,
            okText: '确定'
          })
        }
        this.form.validateFields((err, values) => {
          if (!err) {
            values.query = null
            Object.assign(this.menu, values)
            this.$emit('deleteSave', this.menu.id)
          }
        })
      },
      addChildMenu(selectedKey) {
        if (selectedKey.id === null || selectedKey.id === undefined) {
          return this.$notification['error']({
            message: '错误',
            description: '请选择父级节点',
            duration: 4
          })
        }
        this.form.resetFields()
        this.menu = new Menu()
        this.menu.parent=selectedKey
      },
      addMenu(selectedParentKey) {
        this.form.resetFields()
        const newData = new Menu()
        this.menu = Object.assign({}, newData)
        this.form.setFieldsValue({'parent.id': selectedParentKey})
      },
      refresh() {
        this.menu = []
        this.form.resetFields()
      }
    }
  }
</script>
<style scoped>
</style>